<nav id="sidebar" (click)="stopPropagation($event)" *ngIf="canViewSideMenu">
    <div class="arrowIcon" (click)="dismissSidebar()">
        <span class="material-symbols-outlined ">double_arrow </span>
    </div>
    <div class="h5 contents">
        <ul class="list-unstyled components">
            <li class="menu" *ngIf="!hideMenu.home">
                <div class="side_navbar_part" (click)="HomeNavigate()" [routerLink]="['/Home']">
                    <div class="side_navImage"><span class="material-symbols-outlined">
                            home
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'"> Home</div>
                </div>
            </li>
            <li class="menu">
                <div class="side_navbar_part" routerLinkActive="active" (click)="employeeMenu()">
                    <div class="side_navImage align-self-start">
                        <span class="material-symbols-outlined">
                            person
                        </span>
                    </div>
                    <div class="tag_name employee_detail" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'">
                        <mat-accordion>
                            <mat-expansion-panel [(expanded)]="isPanelExpanded">
                                <mat-expansion-panel-header class="align pl-0"
                                    [style.background-color]="isPanelExpanded ? 'var(--blue)' : ''"
                                    [ngClass]="{'active':isEmpActivated()}" *ngIf="!hideEmployee">
                                    Employee

                                </mat-expansion-panel-header>
                                <ul [ngClass]="salesClass">
                                    <li class="menu" *ngIf="hideMenu.dashboard">
                                        <a routerLinkActive="active" [routerLink]="['/Home/Dashboard']">Employee
                                            Dashboard</a>
                                    </li>
                                    <li class="menu employeeCareer" *ngIf="hideMenu.career">
                                        <mat-accordion>
                                            <mat-expansion-panel [(expanded)]="isCareerPanelExpanded">
                                                <mat-expansion-panel-header
                                                    [ngClass]="{'active':isEmpCareerActivated()}" *ngIf="!hideEmployee">
                                                    Employee Career
                                                </mat-expansion-panel-header>
                                                <ul [ngClass]="salesClass">
                                                    <li>
                                                        <a [routerLink]="['/Home/employee-career/employee-Career-path']"
                                                            routerLinkActive="active"
                                                            (click)="employeeCareerPathNavigate()">Employee Career
                                                            Path</a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/Home/employee-career/employee-Career-program']"
                                                            routerLinkActive="active"
                                                            (click)="employeeCareerProgramNavigate()">Employee Career
                                                            Program</a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/Home/employee-career/employee-Career-request']"
                                                            routerLinkActive="active"
                                                            (click)="employeeCareerRequestNavigate()">Employee Career
                                                            Request</a>
                                                    </li>
                                                </ul>
                                            </mat-expansion-panel>
                                        </mat-accordion>
                                    <li class="menu" *ngIf="hideMenu.skillRepository">
                                        <a routerLinkActive="active" [routerLink]="['/Home/Skill Repository']">Employee
                                            Skill
                                            Repository</a>
                                </ul>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>

            <li class="menu" *ngIf="hideMenu.templates">
                <div class="side_navbar_part" [routerLink]="['/Home/Home/Artifactory Repository']"
                    (click)="templatesNavigate()" routerLinkActive="active">
                    <div class="side_navImage">
                        <span class="material-symbols-outlined">
                            receipt_long
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'"> Artifactory Repository</div>
                </div>
            </li>
            <li class="menu" *ngIf="hideMenu.sales && accessForKMS">
                <div class="side_navbar_part">
                    <div class="side_navImage"><span class="material-symbols-outlined">
                            home
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'">
                        <mat-accordion>
                            <mat-expansion-panel [(expanded)]="isKMSPanelExpanded">
                                <mat-expansion-panel-header class="align pl-2" [ngClass]="{'active':isKMSActivated()}"
                                    [style.background-color]="isKMSPanelExpanded ? 'var(--blue)' : ''"
                                    [style.color]="isKMSPanelExpanded ? 'var(--white)' : ''">
                                    KMS Portal
                                </mat-expansion-panel-header>
                                <ul [ngClass]="salesClass">
                                    <li *ngIf="!hideMenu.salesdashboard">
                                        <a routerLinkActive="active" [routerLink]="['/Home/KMSPortal']"
                                            (click)="caseStudiesNavigate()">Dashboard</a>
                                    </li>
                                    <li *ngIf="!hideMenu.projectcontent">
                                        <a [routerLink]="['Home/KMSPortal/Project Content']"
                                            (click)="approvedProjectsNavigate()" routerLinkActive="active">Project
                                            Content</a>
                                    </li>
                                    <li *ngIf="!hideMenu.pendingapprovals">
                                        <a [routerLink]="['Home/KMSPortal/Pending Approvals']"
                                            (click)="pendingProjectsNavigate()" routerLinkActive="active">Pending
                                            Approvals</a>
                                    </li>
                                    <li *ngIf="!hideMenu.users">
                                        <a [routerLink]="['/users/userlist']" (click)="usersNavigate()"
                                            routerLinkActive="active">Users</a>
                                    </li>
                                </ul>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            <li class="menu" *ngIf="hideMenu.proposals">
                <div class="side_navbar_part" [routerLink]="['/Home/Proposal Repository']" (click)="proposalNavigate()"
                    routerLinkActive="active">
                    <div class="side_navImage">
                        <span class="material-symbols-outlined">
                            note_stack
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'"> Proposal Repository</div>
                </div>
            </li>
            <li class="menu" *ngIf="hideMenu.competency">
                <div class="side_navbar_part" routerLinkActive="active" [routerLink]="['/Home/CMF Portal']">
                    <div class="side_navImage"><span class="material-symbols-outlined">
                            home
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'"> CMF Portal</div>
                </div>
            </li>
            <li class="menu">
                <div class="side_navbar_part" routerLinkActive="active" *ngIf="hideMenu.executive"
                    [routerLink]="['/Home/Executive Dashboard']">
                    <div class="side_navImage">
                        <span class="material-symbols-outlined">
                            team_dashboard
                        </span>
                    </div>
                    <div class="tag_name" [style.width]="isShow ? '215px' : '0'"
                        [style.visibility]="isShow ? 'visible' : 'hidden'"> Executive Dashboard</div>
                </div>
            </li>
            <li class="menu">
                <a routerLinkActive="active" *ngIf="hideMenu.techstack"
                    [routerLink]="['/Home/ProjectTechStack']">Project Tech Stack</a>
            </li>
            <li class="menu cursor-pointer">
                <a routerLinkActive="active" *ngIf="hideMenu.salaryRangeCalcualtor"
                    (click)="salaryRangeNavigate()">Salary Range Calculator</a>
            </li>
            <li class="menu">
                <a routerLinkActive="active" [routerLink]="['/Home/Time Stamp']">Time Stamp</a>
            </li>
        </ul>
    </div>
</nav>